import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import { useTranslation } from "react-i18next";
import { crearAnalisisLaboratorio, crearMedicion } from "../utils/data";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import LabeledValue from "./controls/LabeledValue";
import TextValue from "./controls/TextValue";
import MeasureValue from "./controls/MeasureValue";
import ArrayValue from "./controls/ArrayValue";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import DateValue from "./controls/DateValue";
import { AnalisisLaboratorioForm } from "./AnalisisLaboratorioForm";
import Button from "./controls/Button";

export function CaracterizacionEfluenteForm({
  value,
  page,
  select,
  append,
  replace,
  remove,
  tiposMuestreo,
  unidadPeriodoMuestreo,
  unidadCaudalMedio,
  contaminantes,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Grid>
      <Row>
        <Col>
          <ListGroup>
            {value.map((item, index) => (
              <>
                {index !== page ? (
                  <ListGroupObjectItem
                    index={index}
                    indexLabel={t("analisisLaboratorio.orden")}
                    value={item}
                    editable
                    onEdit={(event) => {
                      event.preventDefault();
                      select(index);
                      document
                        .getElementById("tanquesAcopioLiquidos")
                        .scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                        });
                    }}
                    deletable
                    onDelete={(event) => {
                      event.preventDefault();
                      remove(index);
                    }}
                    disabled={disabled}
                  >
                    {({ value }) => (
                      <Grid>
                        <Row>
                          <Col lg={8}>
                            <TextValue
                              label={t("analisisLaboratorio.protocolo")}
                              value={value.protocolo}
                            />
                          </Col>
                          <Col lg={4}>
                            <DateValue
                              label={t("analisisLaboratorio.fecha")}
                              value={value.fecha}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6}>
                            <TextValue
                              label={t("analisisLaboratorio.laboratorio")}
                              value={value.laboratorio}
                            />
                          </Col>
                          <Col lg={4}>
                            <LabeledValue
                              label={t("analisisLaboratorio.tipoMuestra")}
                              value={value.tipoMuestra}
                              labelAttr="nombre"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={6}>
                            <MeasureValue
                              label={t("analisisLaboratorio.periodoMuestreo")}
                              value={value.periodoMuestreo}
                            />
                          </Col>
                          <Col lg={6}>
                            <MeasureValue
                              label={t("analisisLaboratorio.caudalMedio")}
                              value={value.caudalMedio}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ArrayValue
                              label={t("analisisLaboratorio.resultados")}
                              value={value.resultados}
                            >
                              {({ value }) => (
                                <ListGroup>
                                  <ListGroupItem>
                                    <Grid>
                                      <Row>
                                        <Col lg={1}>#</Col>
                                        <Col lg={4}>
                                          {t("medicion.contaminante")}
                                        </Col>
                                        <Col lg={2}>{t("medicion.signo")}</Col>
                                        <Col lg={4}>
                                          {t("medicion.cantidad")}
                                        </Col>
                                      </Row>
                                    </Grid>
                                  </ListGroupItem>
                                  {value.map((medicion, index) => (
                                    <ListGroupItem key={index}>
                                      <Grid>
                                        <Row>
                                          <Col lg={1}>{index + 1}</Col>
                                          <Col lg={4}>
                                            <LabeledValue
                                              value={medicion.contaminante}
                                              labelAttr="nombre"
                                            />
                                          </Col>
                                          <Col lg={2}>
                                            <TextValue value={medicion.signo} />
                                          </Col>
                                          <Col lg={4}>
                                            <MeasureValue
                                              value={medicion.cantidad}
                                            />
                                          </Col>
                                        </Row>
                                      </Grid>
                                    </ListGroupItem>
                                  ))}
                                </ListGroup>
                              )}
                            </ArrayValue>
                          </Col>
                        </Row>
                      </Grid>
                    )}
                  </ListGroupObjectItem>
                ) : (
                  <ListGroupItem>
                    <Grid>
                      <Row>
                        <Col>
                          <h5 style={{ float: "left" }}>
                            {t("analisisLaboratorio.orden")}&nbsp;{index + 1}
                          </h5>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <AnalisisLaboratorioForm
                            value={item}
                            page={index}
                            select={select}
                            append={append}
                            replace={replace}
                            remove={remove}
                            tiposMuestreo={tiposMuestreo}
                            unidadPeriodoMuestreo={unidadPeriodoMuestreo}
                            unidadCaudalMedio={unidadCaudalMedio}
                            crearMedicion={crearMedicion}
                            contaminantes={contaminantes}
                            disabled={disabled}
                          />
                        </Col>
                      </Row>
                    </Grid>
                  </ListGroupItem>
                )}
              </>
            ))}
            {page === -1 && (
              <ListGroupItem>
                <Grid>
                  <Row>
                    <Col>
                      <h5 style={{ float: "left" }}>
                        {t("analisisLaboratorio.nuevo")}
                      </h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <AnalisisLaboratorioForm
                        value={crearAnalisisLaboratorio(value)}
                        page={page}
                        select={select}
                        append={append}
                        replace={replace}
                        remove={remove}
                        tiposMuestreo={tiposMuestreo}
                        unidadPeriodoMuestreo={unidadPeriodoMuestreo}
                        unidadCaudalMedio={unidadCaudalMedio}
                        crearMedicion={crearMedicion}
                        contaminantes={contaminantes}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              </ListGroupItem>
            )}
          </ListGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          {page !== -1 && (
            <Button
              sm
              style={{
                float: "right",
                marginTop: "10px",
                marginBottom: "10px",
              }}
              variant="success"
              value={t("analisisLaboratorioForm.nuevo")}
              onClick={(event) => {
                event.preventDefault();
                select(-1);
              }}
              disabled={disabled}
            />
          )}
        </Col>
      </Row>
    </Grid>
  );
}
